import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseService } from '../../Services/BaseService';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent implements OnInit {
  message: string;
  imagePath: any;
  imgURL: SafeUrl;
  file: any;
  validPhoto: boolean = true;
  @Input() title: string = '';
  @Input() uploadFiles: boolean = false;
  @Output() sendFormData = new EventEmitter<FormData>();
  uploadedFiles = [];
  formData: FormData;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.formData = new FormData();
  }

  preview(files) {
    if (!files || files.length === 0) return;
    if (!this.uploadFiles) {
      this.formData = new FormData();
      this.file = [];
    }


    const mimeType = files[0].type;
    if (mimeType.match(/image\/svg\+xml/)) {
      // Handle SVG
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = () => {
        this.imgURL = this.sanitizer.bypassSecurityTrustUrl(reader.result as string);
      };
    } else if (mimeType.match(/image\/.*/)) {
      // Handle other images
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = () => {
        this.imgURL = this.sanitizer.bypassSecurityTrustUrl(reader.result as string);
      };
    } else {
      this.message = 'Only images and SVGs are supported.';
      return;
    }

    this.file = files;

    this.validPhoto = true;
    for (const file of this.file) {
      this.formData.append(file.name, file);
    }
    this.sendFormData.emit(this.formData);
  }

  uploadFile(files: any) {
    const formData = new FormData();
    for (let file of files) {
      formData.append(file.name, file);
    }
  }

  uploadMultipleFiles(files: any) {
    const formData = new FormData();
    for (let file of files) {
      formData.append(file.name, file);
    }
  }

  removePhoot() {
    this.imgURL = null;
    this.file = null;
    this.sendFormData.emit(null);
  }
}
